import React from "react";
import "./css/index.css";
import { CouponUserState } from "../../interface/interface";

type Props = {
  ListData: CouponUserState[];
  SpliceUser: ((index: number) => void) | undefined;
};

const CouponUserList = ({ ListData, SpliceUser }: Props) => {
  return (
    <div className="coupon-user-list-section">
      {ListData.map((item, index) => {
        return (
          <div key={index} className={`box `}>
            <div className="number">{item.usr_id}</div>
            <div className="nameid">{item.login_id}</div>
            <div className="email">{item.usr_email}</div>
            <div className="name">{item.login_nm}</div>
            {SpliceUser ? (
              <div
                className="img"
                onClick={() => {
                  SpliceUser(index);
                }}
              >
                <img src="/assets/common/close.svg"></img>
              </div>
            ) : undefined}
          </div>
        );
      })}
    </div>
  );
};

export default CouponUserList;
